package net.frozenbit.games.soundgame.components

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.scaleIn
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.viewmodels.presentation.PlayerTagData
import org.jetbrains.compose.resources.painterResource
import soundgame.app.shared.generated.resources.Res
import soundgame.app.shared.generated.resources.winner_badge

@Composable
internal fun Scoring(
    player: PlayerTagData,
    points: Int?,
    winner: Boolean = false,
    modifier: Modifier = Modifier,
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
    ) {
        PlayerTag(player)
        AnimatedVisibility(
            visible = points != null,
            enter = scaleIn(),
            modifier = Modifier
                .align(Alignment.TopStart)
                .offset((-12).dp, (-12).dp)
        ) {
            PointIndicator(points = points ?: 0,)
        }
        if (winner) {
            Image(
                painter = painterResource(Res.drawable.winner_badge),
                contentDescription = null,
                modifier = Modifier
                    .align(Alignment.CenterStart)
                    .size(64.dp)
                    .offset(-(16).dp, (38).dp)
                    .rotate(-15f)
            )
        }
    }
}